<template>
  <GwMenu
    placement="bottom-start"
    :closeOnContentClick="false"
    :flOptions="{ offset: 0, padding: 0 }"
    :ignoreDataGwmenu="true"
    :zIndexContent="99"
    @open="canDelete = false"
  >
    <template #opener>
      <div
        class="mdi mdi-dots-vertical pa-1 clr-grey icon_btn"
        :data-tst="`ats_opener_${tstPrefix}`"
      ></div>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu f-column"
        style="padding: 0.5rem 0.25rem; gap: 0.25rem"
        data-gwmenu="noclose"
      >
        <div
          v-if="!canDelete"
          class="gw_btn gw_btn_small gw_btn_text text-medium weight_500 w-100"
          style="--height: 1.75rem; --padding: 0 0.5rem; justify-content: flex-start"
          data-tst="ats_rename"
          @click.stop="
            () => {
              $emit('open:detail', item)
              methods.toggleOpen(false)
            }
          "
        >
          {{ $t('common.rename') }}
        </div>
        <div
          v-if="!canDelete"
          class="gw_btn gw_btn_small gw_btn_text text-medium weight_500 w-100 csst csst_nm"
          style="--height: 1.75rem; --padding: 0 0.5rem; justify-content: flex-end"
          @click.stop="copyToClipboard"
        >
          <span
            v-if="!loading"
            style="margin-right: auto"
          >
            {{ $t('btn.export') }}
          </span>
          <LoaderSpinner
            v-else
            style="--size: 1.5rem; margin: auto"
          />
          <div
            v-if="copied"
            class="csst_content text-nowrap csst_content_visible"
            style="background: var(--clr-primary); position: fixed; transform: translateY(-100%)"
            v-html="$t('messages.copied_to_clipboard')"
          ></div>
        </div>
        <div
          v-if="!canDelete"
          data-gwmenu="noclose"
          class="gw_btn gw_btn_small gw_btn_text text-medium weight_500 w-100"
          style="--height: 1.75rem; --padding: 0 0.5rem; justify-content: flex-start"
          data-tst="ats_delete"
          @click="canDelete = !canDelete"
        >
          {{ $t('btn.delete') }}
        </div>
        <div
          v-if="canDelete"
          class="f-column"
          style="gap: 0.25rem"
        >
          <div
            class="gw_btn text-small anim-fade-in w-100"
            style="--clr-back: var(--clr-error); --height: 1.75rem"
            data-gwmenu="noclose"
            data-tst="ats_confirm_delete"
            @click.stop="
              () => {
                $emit('delete:item', item)
                methods.toggleOpen(false)
              }
            "
          >
            {{ $t('btn.confirm_delete') }}
          </div>
          <div
            class="gw_btn text-small anim-fade-in w-100"
            data-gwmenu="noclose"
            @click.stop="canDelete = !canDelete"
          >
            {{ $t('btn.cancel_delete') }}
          </div>
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'

export default {
  name: 'ActionsTreeSettingsMenu',
  components: {
    GwMenu,
    LoaderSpinner,
  },
  props: {
    item: Object,
    tstPrefix: [String, Number],
  },
  emits: ['delete:item', 'open:detail'],
  data() {
    return {
      canDelete: false,
      copied: false,
      loading: false,
    }
  },
  methods: {
    async copyToClipboard() {
      this.loading = true
      const { response, status } = await this.$store.dispatch('api_call', {
        method: 'GET',
        endpoint: `custom-solutions/custom-trees/saved-trees/${this.item.id}/`,
        apiVersion: 'v4',
        hasCancel: false,
        message: {
          type: 'error',
          status: 'err_message',
          statusMessages: {
            _err_message: {
              i18n: `messages.oops_error`,
            },
          },
        },
      })
      this.loading = false

      if (status !== 200) {
        console.error(`error-export-solfigr-settings`)
        return
      }

      const filteredData = { ...response.data }
      ;['created_at', 'id', 'ordering_position', 'tags'].forEach(key => {
        delete filteredData[key]
      })

      const str = JSON.stringify(filteredData)
      navigator.clipboard.writeText(str)

      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 1000)
    },
  },
}
</script>
